import React from "react";
import { Col, Image, Row, Table } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";

const OffersReportsDetails = () => {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={2} />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <Row>
              <Col lg={4} className="pr-lg-0">
                <Col className="pt-4 pb-3">
                  <NavLink to="/reportdashboard" className="f12-500 enBackLink">
                    <Image
                      fluid
                      alt="Back Icon"
                      title="Back Icon"
                      className="mr-2"
                      src={require("../../../../assets/images/UserManagement/backIcon.svg")}
                    />
                    Back
                  </NavLink>
                  <div className="f20_700_HelveticaNeue">
                    Offer- Street Meat
                  </div>
                  <div className="enRestaurantBox mt-3">
                    <div
                      className="enlogo"
                      style={{
                        backgroundImage:
                          "url(" +
                          require("../../../../assets/images/UserManagement/restaurent-img.png") +
                          ")",
                      }}
                    >
                      <div className="enRElogo">
                        <Image
                          src={require("../../../../assets/images/superadmin/streetmeat.png")}
                          alt="Profile pic"
                          title="Profile Pic"
                          fluid
                        />
                      </div>
                    </div>
                    <div className="enContent">
                      <div className="d-flex align-items-center">
                        <div className="f13-700">Get 50% Off</div>
                        <div className="enSuccessLBLSmall ml-2">ONLINE</div>
                      </div>
                      <div className="f11-400 text-gray mt-4">
                        These imply that the net payment is due in either 7, 10,
                        30, 60, or 90 days after the ..... invoice date. For
                        example, if the invoice was dated June 10 and you used
                        one of the most used payment terms, Net 30, then the
                        payment would be expected before July 9.
                      </div>
                    </div>
                  </div>
                </Col>
              </Col>
              <Col lg={8} className="enBgGray enMinHeight100vh">
                <div className="f14-500 opacity5 my-5">
                  Offer ID- 12121252364896
                </div>
                <div className="user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth500">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th className="f11-500" style={{ width: "30%" }}>
                          User Name
                        </th>
                        <th className="f11-500" style={{ width: "15%" }}>
                          Offer
                          <br />
                          Viewed
                        </th>
                        <th className="f11-500" style={{ width: "20%" }}>
                          Viewed
                          <br />
                          Date -Time
                        </th>
                        <th className="f11-500" style={{ width: "15%" }}>
                          Coupon
                          <br />
                          Used
                        </th>
                        <th className="f11-500" style={{ width: "20%" }}>
                          Used
                          <br />
                          Date -Time
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="enUserFavoritesTableBody">
                        <td
                          style={{ width: "30%" }}
                          className="d-flex align-items-start"
                        >
                          <div className="d-flex flex-column align-items-center">
                            <div className="enIMG33 rounded-circle">
                              <Image
                                src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
                                alt="Profile pic"
                                title="Profile Pic"
                                className="h-100 w-100"
                                fluid
                              />
                            </div>
                            <div className="f10-400 pt-2">Akhil Sharma</div>
                          </div>
                        </td>
                        <td style={{ width: "15%" }}>
                          <div className="f10-500">Yes</div>
                        </td>
                        <td style={{ width: "20%" }}>
                          <div className="f10-500">04-07-2020</div>
                          <div className="f10-400">12:30 PM</div>
                        </td>
                        <td style={{ width: "15%" }}>
                          <div className="f10-500">Yes</div>
                        </td>
                        <td style={{ width: "20%" }}>
                          <div className="f10-500">04-07-2020</div>
                          <div className="f10-400">12:30 PM</div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OffersReportsDetails;
